var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.isVisible,
        title: _vm.title,
        "destroy-on-close": true,
      },
      on: { close: _vm.hide },
    },
    [
      _c("move-to-group-form", {
        attrs: {
          "search-url": _vm.searchUrl,
          "store-url": _vm.moveUrl,
          "brand-id": _vm.brandId,
        },
        on: { stored: _vm.onStored },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }